import React from "react";
import CreateBtn from "../../components/buttons/createBtn";
import searcher from "../../assets/icons/searchInput.svg";
import VersionHistoryBtn from "../../components/buttons/versionHistoryBtn";
import MainLayout from "../../components/layout/mainLayout/mainLayout";
import FaqListTable from "./faq-list-table";
import "./faq.css";
import { useLocation, useNavigate } from "react-router-dom";

const FaqList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  return (
    <MainLayout breadCrumb="ADMIN / FAQ’s">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
            <img className="styled-SVG" src={searcher} alt="o" />
            <input
              value={search}
              className="search-input fs_14 text-dark fw_400 px-2"
              type="text"
              placeholder="Search FAQ's here by FAQ ID, FAQ Questions..."
              onChange={(e) =>
                navigate(
                  `/faq?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }`
                )
              }
            />
          </div>
          <div className=" d-flex justify-content-between m-1 mb-2">
            <VersionHistoryBtn link="/faq/version-list" />
            <CreateBtn link="/faq/create" />
          </div>
        </div>
        <FaqListTable search={search} page_no={page_no} />
      </div>
    </MainLayout>
  );
};

export default FaqList;
